import { render, staticRenderFns } from "./JobLogsPanel.vue?vue&type=template&id=674f63b4"
import script from "./JobLogsPanel.vue?vue&type=script&lang=ts"
export * from "./JobLogsPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports